import React, { useState } from 'react';
import './style.scss';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const CustomCheckbox = ({ label, active }) => {
  const [isChecked, setIsChecked] = useState(active);

  return (
    <label
      htmlFor=""
      className={`checkbox-custom flex-align-item-center ${isChecked ? 'checked' : ''}`}
      onClick={() => {
        setIsChecked(!isChecked);
      }}
    >
      <input type="checkbox" checked={isChecked} onChange={() => {}} />
      <svg
        className="checkbox"
        aria-hidden="true"
        width="10"
        height="9"
        viewBox="0 0 10 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 1.6342L5.32597 6.53515V6.53515L3.76797 8.16894L2.20996 6.53515L2.21861 6.52609L0 4.17446L1.55842 2.54067L3.77662 4.89271L8.44199 0L10 1.6342Z"
          fill={isChecked ? 'white' : 'none'}
        />
      </svg>
      <span className="label">
        <Text field={label} />
      </span>
    </label>
  );
};

export default CustomCheckbox;
